export default __webpack_public_path__ + "static/media/flash12.c215920a.png";